import React from 'react'
import { Popover, type PopoverProps } from 'antd'
import { QuestionCircleOutlined } from '@ant-design/icons'

export type InfoTooltipProps = PopoverProps & {
  /** Optional styling for the icon */
  iconStyle?: React.CSSProperties
  /** Optional className for the icon */
  iconClassName?: string
  /** Max width for the popover overlay (default: 300) */
  maxWidth?: number | string
}

export function InfoTooltip({
  iconStyle,
  iconClassName,
  maxWidth = 300,
  overlayInnerStyle,
  children,
  ...popoverProps
}: InfoTooltipProps) {
  return (
    <Popover
      {...popoverProps}
      overlayInnerStyle={{
        maxWidth,
        ...overlayInnerStyle,
      }}
    >
      <span
        className={iconClassName}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          cursor: 'help',
          color: 'rgba(0; 0; 0; 0.45)',
          ...iconStyle,
        }}
      >
        <QuestionCircleOutlined />
      </span>
    </Popover>
  )
}
